<template>
    <div style="margin-top: 155px;">
        <div class="footer">
            <div class="wrap">
                <ul>
                    <li><span></span></li>
                    <li><span></span></li>
                    <li><a href="https://www.linkedin.com/company/multimetaverse-inc" target="_blank"><div class="line_to"></div></a></li>
                </ul>
                <span class="reserved"
                    >© 2022 MultiMetaVerse Inc., all rights reserved.</span
                >
            </div>
        </div>
    </div>
</template>
<script>
export default{
    mounted(){
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://qmod.quotemedia.com/js/qmodLoader.js';
        script.id = 'qmod';
        script.setAttribute('data-qmod-wmid', '104618')
        // script.setAttribute('data-qmod-wmid', '101894')
        document.body.appendChild(script);
    }
}
</script>
<style lang="less" scoped>
.wrap {
    width: 1200px;
    margin: 0 auto;
}
.footer {
    background: #262f4b;
    height: 155px;
    line-height: 155px;
    color: rgba(255, 255, 255, 0.5);
    /* filter: brightness(0.65); */
    font-size: 12px;
    width: 100%;
    position: absolute;
    bottom: 0;
}
.footer ul {
    display: flex;
    float: left;
}
.footer ul span {
    margin: 0 10px;
}
.footer ul span:hover {
    cursor: pointer;
    color: #ffffff;
}
.reserved {
    float: right;
}
.line_to{
    width: 23px;
    height: 23px;
    background: url("../../assets/about/Lin_in.png") no-repeat center center;
    background-size: 100%;
    border-radius: 5px;
    position: relative;
    top: 42%;
    left: 20px;
}
</style>